<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="main">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" offset="100" @load="onLoad">
      <div class="search-area">
        <div class="area-select-area">
          <van-field readonly clickable :value="query.province" placeholder="选择省" right-icon="arrow-down"
            :border="false" @click="showProvincePicker = true" />
          <van-field readonly clickable :value="query.city" placeholder="选择市" right-icon="arrow-down" :border="false"
            @click="showCityPicker = true" />
          <van-field readonly clickable :value="query.district" placeholder="选择区" right-icon="arrow-down"
            :border="false" @click="showDistrictPicker = true" />
        </div>
        <van-search placeholder="请输入门店名称" left-icon="" v-model="query.storeName"></van-search>
        <div class="search-btn-area">
          <van-button color="#FEF0E8" icon="search" class="search-btn" @click="search">搜索</van-button>
          <van-button @click="reset">重置</van-button>
        </div>
      </div>
      <div class="store-area">
        <div class="item" v-for="(item, index) in storeList" :key="index">
          <div class="title"><span>{{ item.storeName }} </span><span
              :class="getStoreNatureClass(item.storeNatureDesc)">{{ item.storeNatureDesc
              }}</span></div>
          <div class="distance-tel">
            <div class="distance" v-if="item.distance">距您{{ item.distance }}km</div>

            <div class="tel" v-if="item.phone">
              <img src="../../assets/tel.png">
              <a :href="'tel:' + item.phone">{{ item.phone }}</a>
            </div>
          </div>
          <div class="address" @click="location(item)">
            <img src="../../assets/nav_icon.png">
            <span>{{ item.storeAddress }}</span>
          </div>
        </div>
      </div>
      <van-popup v-model="showProvincePicker" round position="bottom">
        <van-picker show-toolbar value-key="name" :columns="provinceList" @cancel="showProvincePicker = false"
          @confirm="confirmProvince" />
      </van-popup>
      <van-popup v-model="showCityPicker" round position="bottom">
        <van-picker show-toolbar value-key="name" :columns="cityList" @cancel="showCityPicker = false"
          @confirm="confirmCity" />
      </van-popup>
      <van-popup v-model="showDistrictPicker" round position="bottom">
        <van-picker show-toolbar value-key="name" :columns="districtList" @cancel="showDistrictPicker = false"
          @confirm="confirmDistrict" />
      </van-popup>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import { selectAreaProvince, selectAreaCity, selectAreaDistrict, pageStoreDo } from '../../apis/cityOutlets'
import wxLocation from '@/utils/wxLocation'
import { isWeixin } from '../../utils/index.js'
const QUERY = {
  province: '',
  provinceId: '',
  city: '',
  cityId: '',
  district: '',
  districtId: '',
  storeName: '',
  latitude: '',
  longitude: ''
}
export default {
  name: 'cityOutlets',
  data() {
    return {
      page: 0,
      pageSize: 5,
      showProvincePicker: false,
      showCityPicker: false,
      showDistrictPicker: false,
      query: {
        ...QUERY
      },
      provinceList: [],
      cityList: [],
      districtList: [],
      storeList: [],
      loading: false,
      finished: true,
      refreshing: false
    }
  },
  methods: {
    _pageStoreDo() {
      let { page, pageSize } = this
      let { provinceId, cityId, districtId, storeName, latitude, longitude } = this.query
      let params = {
        pageNum: page,
        pageSize,
        provinceId,
        cityId,
        districtId,
        storeName,
        latitude,
        longitude
      }
      pageStoreDo(params).then(res => {
        this.storeList.push(...res.data)
        this.page++
        this.loading = false
        if (res.data.length < this.page) {
          this.finished = true;
        }
      })
    },
    _selectAreaProvince() {
      selectAreaProvince({}).then(res => {
        this.provinceList = res.data
      })
    },
    _selectAreaCity() {
      let params = {
        parentId: this.query.provinceId
      }
      selectAreaCity(params).then(res => {
        this.cityList = res.data
      })
    },
    _selectAreaDistrict() {
      let params = {
        parentId: this.query.cityId
      }
      selectAreaDistrict(params).then(res => {
        this.districtList = res.data
      })
    },
    search() {
      this.refreshing = true
      this.onRefresh()
    },
    reset() {
      this.query.province = ''
      this.query.provinceId = ''
      this.query.city = ''
      this.query.cityId = ''
      this.query.district = ''
      this.query.districtId = ''
      this.query.storeName = ''
      this.cityList = []
      this.districtList = []
      this.refreshing = true
      this.onRefresh()
    },
    confirmProvince(val) {
      this.query.province = val.name
      this.query.provinceId = val.id
      this._selectAreaCity()
      this.query.city = ''
      this.query.cityId = ''
      this.query.district = ''
      this.query.districtId = ''
      this.showProvincePicker = false
    },
    confirmCity(val) {
      this.query.city = val.name
      this.query.cityId = val.id
      this._selectAreaDistrict()
      this.query.district = ''
      this.query.districtId = ''
      this.showCityPicker = false
    },
    confirmDistrict(val) {
      this.query.district = val.name
      this.query.districtId = val.id
      this.showDistrictPicker = false
    },
    onLoad() {
      if (this.refreshing) {
        this.storeList = []
        this.page = 0
        this.refreshing = false;
      }
      this._pageStoreDo()
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    location(data) {
      if (isWeixin()) {
        wxLocation.openLocation(data)
      }
    },
    getStoreNatureClass(storeNatureDesc) {
      if (storeNatureDesc === '销售店') {
        return 'storeNatureDesc-orange';
      } else if (storeNatureDesc === '服务站') {
        return 'storeNatureDesc-blue';
      } else if (storeNatureDesc === '销服一体店') {
        return 'storeNatureDesc-red';
      } else {
        return '';
      }
    }
  },
  async mounted() {
    if (isWeixin()) {
      let res = await wxLocation.getLocation()
      if (res) {
        this.query.latitude = res.latitude
        this.query.longitude = res.longitude
      }
    }
    this.onRefresh()
    this._selectAreaProvince()
  },

}
</script>

<style lang="scss" scoped>
.main {
  background: #F7F7F7;
  height: 100vh;
  overflow: auto;
}

.search-area {
  background: #fff;
  padding-bottom: 15px;
}

.area-select-area {
  display: flex;
}

.van-button--normal {
  padding: 0;
  font-size: 13px;
  width: 110px;
  border-radius: 4px;
  height: 32px;
}

.search-btn-area {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.search-btn {
  margin-right: 40px;

  .van-button__content {
    color: #F3671B;
  }
}

.store-area {
  padding: 15px;
  text-align: left;

  .item {
    padding: 15px;
    background: #fff;
    border-radius: 6px;
    margin-bottom: 15px;

    .title {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      color: #333;
      font-weight: bold;
    }

    .storeNatureDesc-blue {
      padding: 4px 6px;
      border-radius: 16px 16px 16px 0px;
      background: #E8F3FF;
      text-align: center;
      color: #165DFF;
      font-size: 14px;
    }

    .storeNatureDesc-orange {
      padding: 4px 6px;
      border-radius: 16px 16px 16px 0px;
      background: #FFF1E9;
      text-align: center;
      color: #FF821D;
      font-size: 14px;
    }

    .storeNatureDesc-red{
      padding: 4px 6px;
      border-radius: 16px 16px 16px 0px;
      background: #FFF4F4;
      text-align: center;
      color: #FF232D;
      font-size: 14px;
    }
  }

  .distance-tel {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0;

    .distance {
      color: #999999;
      font-size: 12px;
    }

    .tel {
      font-size: 14px;
      display: flex;
      align-items: center;

      a {
        color: #4DC76E;
      }

      img {
        width: 17px;
      }
    }
  }

  .address {
    font-size: 12px;
    color: #666;
    display: flex;
    align-items: center;

    img {
      width: 25px;
      margin-right: 5px;
    }
  }
}
</style>